import { cn } from "@/lib/utils";
import fullAsset from "@/assets/brand/ssufc-logo-full.png.asset.json";
import iconAsset from "@/assets/brand/ssufc-icon.png.asset.json";

/**
 * Official Soweto Super United FC brand mark. Renders the real uploaded
 * artwork (full logotype or emblem-only), never a generated placeholder.
 *
 * - variant="full"  — emblem + wordmark. Use in main headers, footers,
 *                     login/auth pages, about/history hero, print views.
 * - variant="icon"  — emblem only (with motto ribbon). Use in compact
 *                     placements: mobile chrome, admin sidebar, favicons,
 *                     league-table rows, scoreboards, watermarks.
 */
export function ClubLogo({
  variant = "icon",
  className,
  alt = "Soweto Super United FC",
  priority = false,
  decorative = false,
}: {
  variant?: "full" | "icon";
  className?: string;
  alt?: string;
  priority?: boolean;
  decorative?: boolean;
}) {
  const src = variant === "full" ? fullAsset.url : iconAsset.url;
  return (
    <img
      src={src}
      alt={decorative ? "" : alt}
      aria-hidden={decorative || undefined}
      loading={priority ? "eager" : "lazy"}
      decoding={priority ? "sync" : "async"}
      fetchPriority={priority ? "high" : "auto"}
      draggable={false}
      className={cn(
        variant === "full"
          ? "h-auto w-auto max-h-16 object-contain"
          : "h-auto w-auto object-contain",
        className,
      )}
    />
  );
}

export const clubLogoAssets = {
  full: fullAsset.url,
  icon: iconAsset.url,
};
